import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default class CableDraw {
    constructor(options = {}) {
        this.params = {
            selector: ".js-cable",
            trigger: "scroll",
            skipAnimation: false,
            start: "top 50%",
            duration: 3.5,
            ease: "none",
            ...options,
        };

        this.isReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

        [...document.querySelectorAll(this.params.selector)].forEach((wrap) => this.setup(wrap));
    }

    setup(wrap) {
        const path = wrap.querySelector("path");
        if (!path) return;

        const length = path.getTotalLength();

        // 始点が下にあるパスは終点側から描いて見た目を上→下に揃える
        const reverse = path.getPointAtLength(0).y > path.getPointAtLength(length).y;
        const hidden = length;
        const visible = reverse ? length * 2 : 0;

        // 同一階層の遷移・motion低減設定では完成形を表示
        if (this.params.skipAnimation || this.isReducedMotion) {
            gsap.set(path, { strokeDashoffset: 0 });
            return;
        }

        gsap.set(path, { strokeDasharray: `${length} ${length}`, strokeDashoffset: hidden });

        const play = () => {
            gsap.to(path, {
                strokeDashoffset: visible,
                duration: this.params.duration,
                ease: this.params.ease,
            });
        };

        // 下層ページはスクロールを待たず、読み込み完了後に描画する
        if (this.params.trigger === "load") {
            if (document.readyState === "complete") {
                play();
            } else {
                window.addEventListener("load", play, { once: true });
            }
            return;
        }

        ScrollTrigger.create({
            trigger: wrap,
            start: this.params.start,
            once: true,
            onEnter: play,
        });
    }
}
